import { useEffect, useState } from 'react'
import { AuthServices } from '../util/authServices';

const GestionUsuarios = ({ setUserSession, setViewAdminZone, userSession, setCargando, toast }) => {

    const listOptionsRoles = ["Seleccione", "USUARIO_ADMIN", "USUARIO_OPERACIONES"]
    const [listUsersApp, setListUsersApp] = useState([])
    const [nombre, setNombre] = useState('')
    const [apellido, setApellido] = useState('')
    const [role, setRole] = useState('Seleccione')

    useEffect(() => {
        getListUserApp()
    }, [])

    const closeSession = () => {
        setUserSession({
            nombre: "",
            apellido: "",
            usuario: "",
            role: "USUARIO_LOGIN"
        })
        sessionStorage.removeItem('userSessionStorage')
    }

    const actionNavigate = (action) => {
        setViewAdminZone(action)
    }

    const cargarUsuarioApp = () => {
        if (nombre.length > 2 && apellido.length > 2 && role !== 'Seleccione') {
            cargarRegistroUserApp()
        } else {
            toast('Algunos campos son requeridos')
        }
    }

    const validaDisplayPass = (userApp) => {
        if (userApp.activo) {
            return (
                <>
                    <button className='btn btn-link btn-close-modal' onClick={() => actualizaPassScortService(userApp.usuario)} >Reset</button>
                </>
            )
        } else {
            return (
                <>
                    <p style={{ padding: "0px 15px" }}>{userApp.password}</p>
                </>
            )
        }
    }

    const validaDisplayEliminaUser = (userApp) => {
        if (userSession.role === 'USUARIO_ROOT') {
            return (
                <>
                    <button className='btn btn-link btn-close-modal' onClick={() => eliminarUserApp(userApp.usuario)} >X</button>
                </>
            )
        } else {
            return (
                <></>
            )
        }
    }

    const validaDisplayEliminaUserLabel = () => {
        if (userSession.role === 'USUARIO_ROOT') {
            return (
                <>
                    <p className='p-label-report'>Eliminar</p>
                </>
            )
        } else {
            return (
                <></>
            )
        }
    }

    const eliminarUserApp = async (usuario) => {
        setCargando(true)
        const authServices = new AuthServices();
        try {
            const body = {
                "usuarioApp": usuario,
            }
            const response = await authServices.requestPost(body, 4);
            const { estado, mensaje } = response.data;
            if (estado) {
                getListUserApp()
            }
            setCargando(false);
            toast(mensaje)
        } catch (error) {
            setCargando(false);
            toast("Error de comunicación")
        }
    }

    const getListUserApp = async () => {
        setCargando(true)
        const authServices = new AuthServices();
        try {
            const body = {
                "roleConsulta": userSession.role,
            }
            const response = await authServices.requestPost(body, 5);
            const { estado, mensaje, objeto } = response.data;
            if (estado) {
                setListUsersApp(objeto)
            } else {
                toast(mensaje)
            }
            setCargando(false);
        } catch (error) {
            setCargando(false);
            toast("Error de comunicación")
        }
    }

    const cargarRegistroUserApp = async () => {
        setCargando(true)
        const authServices = new AuthServices();
        try {
            const body = {
                "nombreUserApp": nombre,
                "apellidoUserApp": apellido,
                "roleUserApp": role
            }
            const response = await authServices.requestPost(body, 6);
            const { estado, mensaje } = response.data;
            if (estado) {
                getListUserApp()
                setNombre('')
                setApellido('')
                setRole('Seleccione')
            }
            toast(mensaje)
            setCargando(false);
        } catch (error) {
            setCargando(false);
            toast("Error de comunicación")
        }
    }

    const actualizaPassScortService = async (usuario) => {
        setCargando(true)
        const authServices = new AuthServices();
        try {
            const body = {
                "usuario": usuario,
            }
            const response = await authServices.requestPost(body, 7);
            const { estado, mensaje } = response.data;
            if (estado) {
                getListUserApp()
            }
            toast(mensaje)
            setCargando(false);
        } catch (error) {
            setCargando(false);
            toast("Error de comunicación")
        }
    }

    return (
        <>
            <div className='div-container'>
                <div className="row m-0">
                    <div className="col-6 col-sm-6 col-md-6 col-lg-6" >
                        <div className='div-name-user'>
                            <p>{`${userSession.nombre} ${userSession.apellido}`}</p>
                        </div>
                    </div>
                    <div className="col-6 col-sm-6 col-md-6 col-lg-6" >
                        <div className='div-close-info' style={{ height: "3rem" }}>
                            <button className='btn btn-link btn-close-modal' onClick={() => actionNavigate('HOME')} >Volver a menú</button>
                            <button className='btn btn-link btn-close-modal' onClick={() => closeSession()} >Cerrar</button>
                        </div>
                    </div>
                </div>
                <hr className='hr-report' />
            </div>            
            <div className='div-container'>
                <div className="row m-0">
                    <div className="col-12 col-sm-12 col-md-4 col-lg-4" >
                        <div className='div-inputs-login'>
                            <p className='p-label-form'> Nombre </p>
                            <input type="text" name='nombre' value={nombre} onChange={(e) => setNombre(e.target.value)} className='form-control' autoComplete='off' />
                        </div>
                        <div className='div-inputs-login'>
                            <p className='p-label-form'> Apellido </p>
                            <input type="text" name='apellido' value={apellido} onChange={(e) => setApellido(e.target.value)} className='form-control' autoComplete='off' />
                        </div>
                        <div className='div-inputs-login'>
                            <p className='p-label-form'> Role </p>
                            <select className='form-control' value={role} onChange={(e) => setRole(e.target.value)}>
                                {
                                    listOptionsRoles.map((key, i) => {
                                        return (
                                            <option key={i} value={key}>{key}</option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                        <div className="div-ajusta-content mt-3" >
                            <div className='div-inputs-login'>
                                <button className='btn btn-primary custom-btn' onClick={() => cargarUsuarioApp()} >
                                    Cargar usuario APP
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-8 col-lg-8" >
                        <div className='div-container-report-list' >
                            <div className="row m-0">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-3 div-report-data" >
                                    <p className='p-label-report'>Nombres</p>
                                </div>
                                <div className="col-12 col-sm-12 col-md-12 col-lg-2 div-report-data" >
                                    <p className='p-label-report'>Usuario</p>
                                </div>
                                <div className="col-12 col-sm-12 col-md-12 col-lg-3 div-report-data" >
                                    <p className='p-label-report'>Contraseña</p>
                                </div>
                                <div className="col-12 col-sm-12 col-md-12 col-lg-3 div-report-data" >
                                    <p className='p-label-report'>Role</p>
                                </div>
                                <div className="col-12 col-sm-12 col-md-12 col-lg-1 div-report-data" >
                                    {
                                        validaDisplayEliminaUserLabel()
                                    }
                                </div>
                            </div>
                            {
                                listUsersApp?.map((userApp) => {
                                    return (
                                        <>
                                            <div className="row m-0">
                                                <div className="col-12 col-sm-12 col-md-12 col-lg-3 div-report-data" >
                                                    {userApp.nombre} {userApp.apellido}
                                                </div>
                                                <div className="col-12 col-sm-12 col-md-12 col-lg-2 div-report-data" >
                                                    {userApp.usuario}
                                                </div>
                                                <div className="col-12 col-sm-12 col-md-12 col-lg-3 div-report-data" >
                                                    <div className='div-action-gestion-usu-app' >
                                                        {
                                                            validaDisplayPass(userApp)
                                                        }
                                                    </div>
                                                </div>
                                                <div className="col-12 col-sm-12 col-md-12 col-lg-3 div-report-data" >
                                                    {userApp.role}
                                                </div>
                                                <div className="col-12 col-sm-12 col-md-12 col-lg-1 div-report-data" >
                                                    <div className="div-buttom-action-gest-user-app" >
                                                        {
                                                            validaDisplayEliminaUser(userApp)
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )
                                })
                            }
                        </div>
                        <div className='div-container-report-list-response margin-control' >
                            {
                                listUsersApp?.map((userApp) => {
                                    return (
                                        <>
                                        <div className='div-report-data-response' >
                                                <p className='p-label-report'>Usuario</p>
                                                <div className='p-label-report-response'>
                                                    {userApp.usuario}
                                                </div>
                                            </div>
                                            <div className='div-report-data-response' >
                                                <p className='p-label-report'>Nombre</p>
                                                <div className='p-label-report-response'>
                                                    {userApp.nombre}
                                                </div>
                                            </div>
                                            <div className='div-report-data-response' >
                                                <p className='p-label-report'>Apellido</p>
                                                <div className='p-label-report-response'>
                                                    {userApp.apellido}
                                                </div>
                                            </div>
                                            <div className='div-report-data-response' >
                                                <p className='p-label-report'>Contraseña</p>
                                                <div className='p-label-report-response'>
                                                    {userApp.password}
                                                    <button className='btn btn-link btn-close-modal' style={{ padding: "0px 0px 0px 10px" }} onClick={() => actualizaPassScortService(userApp.usuario)} >Reset</button>
                                                </div>
                                            </div>
                                            <div className='div-report-data-response' >
                                                <p className='p-label-report'>Role</p>
                                                <div className='p-label-report-response'>
                                                    {userApp.role}
                                                </div>
                                            </div>
                                            <hr className='hr-report' />
                                        </>
                                    )
                                })
                            }

                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default GestionUsuarios